// src/components/Dialogs/EditChatDialog.tsx
import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Typography,
  TextField,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

interface EditChatDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  chatName: string;
  onChatNameChange: (value: string) => void;
}

export const EditChatDialog: React.FC<EditChatDialogProps> = ({
  open,
  onClose,
  onSave,
  chatName,
  onChatNameChange,
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: theme.palette.background.paper,
          background: theme.palette.background.paper,
          padding: "16px",
        },
      }}
    >
      <DialogTitle>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <EditOutlinedIcon
            style={{ marginBottom: 16, color: theme.palette.primary.main }}
          />
          <Typography variant="h6" style={{ fontWeight: 600 }}>
            แก้ไขชื่อห้องสนทนา
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          sx={{ mt: 2 }}
        >
          <TextField
            autoFocus
            margin="dense"
            label="ชื่อห้องสนทนา"
            fullWidth
            value={chatName}
            onChange={(e) => onChatNameChange(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%" gap={2}>
          <Button
            onClick={onClose}
            color="primary"
            variant="outlined"
            fullWidth
          >
            ยกเลิก
          </Button>
          <Button
            onClick={onSave}
            color="primary"
            variant="contained"
            fullWidth
          >
            บันทึก
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
